/**
 *   Generated file. Do not edit
 */

import { SlaveServerRawConfig } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readSlaveServerRawConfig(): SlaveServerRawConfig;
  }
  export interface TapStreamWriter {
    writeSlaveServerRawConfig(model: SlaveServerRawConfig): TapStreamWriter;
  }
}

TapStreamReader.prototype.readSlaveServerRawConfig =
  function (): SlaveServerRawConfig {
    const model: Partial<SlaveServerRawConfig> = {};

    model.channel = this.readUnsigned(1);

    model.length = this.readUnsigned(1);

    model.config = this.readBytes(model.length);

    return model as SlaveServerRawConfig;
  };

// TapStreamWriter.prototype.write(model: SlaveServerRawConfig) : TapStreamWriter{
//     return this.writeSlaveServerRawConfig(model)
// }

TapStreamWriter.prototype.writeSlaveServerRawConfig = function (
  model: SlaveServerRawConfig,
): TapStreamWriter {
  this.writeBitsInt(
    enumKeyOrValueToNumber<SlaveServerRawConfig.Channel>(
      model.channel,
      SlaveServerRawConfig.Channel,
    ),
    8,
  );

  this.writeUnsigned(model.length, 1);

  this.writeBytes(model.config, model.length);

  return this;
};
